import { createRoot } from 'react-dom/client';

import { AppRouter } from '@/app/Router';
import { i18nReady } from '@/shared/i18n';
import '@/shared/design/global.css';

import { Providers } from '@/app/providers';

const container = document.getElementById('root');
if (!container) throw new Error('Root container #root is missing in index.html');

/**
 * Ждём инициализацию i18next перед первым рендером. Без этого дерево
 * монтируется раньше словарей и на экране остаются сырые ключи вместо текста.
 * Заглушка `#sg-boot` из index.html держит первый кадр до готовности.
 */
void i18nReady.finally(() => {
  document.getElementById('sg-boot')?.remove();

  createRoot(container).render(
    <Providers>
      <AppRouter />
    </Providers>,
  );
});
